import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  panel: {
    backgroundColor: theme.vars.palette.background.elevation2,
    borderRadius: 4,
    boxShadow: theme.shadows[2],
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowY: 'hidden',
    position: 'relative'
  },
  panelActionsContainer: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0
  },
  panelCloseButton: {
    marginLeft: theme.spacing(1)
  },
  panelContent: {
    overflowY: 'auto',
    padding: '1rem'
  },
  panelHeader: {
    alignItems: 'center',
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    display: 'flex',
    fontWeight: 600,
    justifyContent: 'space-between',
    padding: '.75rem 1.18rem .75rem 1rem',
    height: '48px',
    '& h4': {
      margin: '0'
    },
    '& > .MuiCardHeader-content': {
      alignItems: 'center',
      display: 'flex',
      flex: '1 1 0%',
      minWidth: 0,
      marginRight: theme.spacing(1)
    },
    '& > .MuiCardHeader-action': {
      flexShrink: 0,
      alignSelf: 'center',
      marginTop: 0,
      marginLeft: 'auto'
    }
  },
  panelHeaderTitleText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '1rem',
    fontWeight: 'bold'
  }
}));

export default useStyles;
